import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { FaBars } from 'react-icons/fa';
import { FaMobileAlt, FaEnvelope, FaFacebookF, FaTwitter, FaLinkedin, FaInstagram, FaSearch } from 'react-icons/fa';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import HeroSection from './components/HeroSection';
import Header from './components/Header';
import Footer from './pages/Footer';
import TermsConditions from './pages/TermsConditions';
import PricingSection from './pages/PricingSection';
import PrivacyPolicy from './pages/PrivacyPolicy';
import AboutSection from './pages/AboutSection';
import Service from './pages/Service';
import Packages from './pages/Packages';
import Pricing from './pages/Booking';
// import Gallery from './pages/Gallery';
import ContactDetails from './pages/ContactDetails';
import Enquiry from './pages/Enquiry';
import OurFleet from './pages/OurFleet';
import Punetokohlapur from './pages/Pune to Kolhapur Cab';
import ScrollToTop from './components/ScrollToTop';
import ContactButtons from './components/ContactButtons';
import Punetomumbaicab from './pages/Pune to Mumbai Cab';
import Punetosanglicab from './pages/Pune to Sangli Cab';
import Punetomahabaleshwar from './pages/Pune to Mahabaleshwar Cab';
import Punetobhimashankarcab from './pages/Pune to Bhimashankar Cab';
import Punetoshirdicab from './pages/Pune to Shirdi Cab';
import Punetonashikcab from './pages/Pune to Nashik Cab';
import Puneairportpickupanddrop from './pages/Pune Airport Pickup and Drop';
import Punetomumbaiairportcab from './pages/Pune To Mumbai Airport Cab';
import Mumbaitopunecab from './pages/Mumbai To Pune Cab';
import Mumbaitomahabaleshwer from './pages/Mumbai To Mahabaleshwar Cab';
import Mumbaitokohlapur from './pages/Mumbai To Kolhapur Cab';
import Mumbaitoshirdi from './pages/Mumbai To Shirdi Cab';
import Mumbaitonashikcab from './pages/Mumbai To Nashik Cab';
import Mumbaiairporttopunecabs from './pages/Mumbai Airport To Pune Cab';
import Kohlapurtopunecab from './pages/Kolhapur to Pune Cab';
import Kohlapurtomumbai from './pages/Kolhapur to Mumbai Cab';
import Sanglitopunecab from './pages/Sangli to Pune Cab';
import Onewaytaxiinpune from './pages/One-Way Taxi in Pune';
import Bestcabserviceinpune from './pages/Best Cab Service in Pune';
import Outstationcabservice from './pages/Outstation Cabs Pune';
import Swiftdezirehireinpune from './pages/Swift Dzire Hire in Pune';
import Xcenthyundaionrentinpune from './pages/Xcent Hyundai On Rent in Pune';
import Nexaciazonrent from './pages/Nexa Ciaz On Rent in Pune';
import Hondacityonrentinpune from './pages/Honda City On Rent in Pune';
import Ertigaonrentinpune from './pages/Ertiga On Rent in Pune';
import Innovacabforout from './pages/Innova Cab for Outstation in Pune';
import Innovacrystaonrentinpune from './pages/Innova Crysta on Rent in Pimpri Chinchwad';
import Fortuneronrentinpune from './pages/Fortuner On Rent in Pune';
import Mercendesonrentinpune from './pages/Mercedes On Rent in Pune';
import Audionrentinpune from './pages/Audi on Rent in Pune';
import Bmwonrentinpune from './pages/BMW On Rent in Pune';
import Jaguarhireinpune from './pages/Jaguar Hire in Pune';
import Tatawingeronrentinpune from './pages/Tata Winger On Rent in Pune';
import Tempotravelleronrent from './pages/Tempo Traveller On Rent in Pune';
import Urbaniaonrentinpune from './pages/Urbania On Rent in Pune';
import Buttontoptop from './components/ScrollToTopButton';



function App() {
  return (
    <Router>
    <ScrollToTop/>
    <ContactButtons/>
   <Buttontoptop/>
    <Header/>
      <Routes>
        
        <Route path="/" element={<HeroSection/>} />
        <Route path="/term-condition" element={<TermsConditions/>} />
        <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
        <Route path="/about" element={<AboutSection/>} />
        <Route path="/services" element={<Service/>} />
        <Route path="/our-fleets" element={<OurFleet/>} />
        <Route path="/package" element={<Packages/>} />
        <Route path="/booking" element={<Pricing/>} />
        {/* <Route path="/gallery" element={<Gallery/>} /> */}
        <Route path="/contact" element={<ContactDetails/>} />
        <Route path="/enquiry" element={<Enquiry/>} />
        <Route path="/Pune-to-Kolhapur-Cab" element={<Punetokohlapur/>} />
        <Route path="/Pune-to-Mumbai-Cab" element={<Punetomumbaicab/>} />
        <Route path="/Pune-to-Sangli-Cab" element={<Punetosanglicab/>} />

        <Route path="/Pune-to-Mahabaleshwar-Cab" element={<Punetomahabaleshwar />} />
<Route path="/Pune-to-Bhimashankar-Cab" element={<Punetobhimashankarcab />} />
<Route path="/Pune-to-Shirdi-Cab" element={<Punetoshirdicab />} />
<Route path="/Pune-to-Nashik-Cab" element={<Punetonashikcab />} />
<Route path="/Pune-Airport-Pickup-and-Drop" element={<Puneairportpickupanddrop />} />
<Route path="/Pune-To-Mumbai-Airport-Cab" element={<Punetomumbaiairportcab />} />
<Route path="/Mumbai-To-Pune-Cab" element={<Mumbaitopunecab />} />
<Route path="/Mumbai-To-Mahabaleshwar-Cab" element={<Mumbaitomahabaleshwer />} />
<Route path="/Mumbai-To-Kolhapur-Cab" element={<Mumbaitokohlapur />} />
<Route path="/Mumbai-To-Shirdi-Cab" element={<Mumbaitoshirdi />} />

<Route path="/Mumbai-To-Nashik-Cab" element={<Mumbaitonashikcab />} />
<Route path="/Mumbai-Airport-To-Pune-Cab" element={<Mumbaiairporttopunecabs />} />
<Route path="/Kolhapur-To-Pune-Cab" element={<Kohlapurtopunecab />} />
<Route path="/Kolhapur-To-Mumbai-Cab" element={<Kohlapurtomumbai />} />
<Route path="/Sangli-To-Pune-Cab" element={<Sanglitopunecab />} />
<Route path="/One-Way-Taxi-in-Pune" element={<Onewaytaxiinpune />} />
<Route path="/Best-cab-service-in-Pune" element={<Bestcabserviceinpune />} />
<Route path="/Outstation-cabs-Pune" element={<Outstationcabservice />} />

<Route path="/Swift-Dzire-Hire-in-Pune" element={<Swiftdezirehireinpune />} />
<Route path="/Xcent-Hyundai-On-Rent-in-Pune" element={<Xcenthyundaionrentinpune />} />
<Route path="/Nexa-Ciaz-On-Rent-in-Pune" element={<Nexaciazonrent />} />
<Route path="/Honda-City-On-Rent-In-Pune" element={<Hondacityonrentinpune />} />
<Route path="/Ertiga-On-Rent-in-Pune" element={<Ertigaonrentinpune />} />
<Route path="/Innova-Cab-for-Outstation-in-Pune" element={<Innovacabforout />} />
<Route path="/Innova-Crysta-on-Rent-in-Pimpri-Chinchwad" element={<Innovacrystaonrentinpune />} />
<Route path="/Fortuner-On-Rent-in-Pune" element={<Fortuneronrentinpune />} />
<Route path="/Mercedes-On-Rent-in-Pune" element={<Mercendesonrentinpune />} />
<Route path="/Audi-On-Rent-in-Pune" element={<Audionrentinpune />} />
<Route path="/BMW-On-Rent-in-Pune" element={<Bmwonrentinpune />} />
<Route path="/Jaguar-Hire-in-Pune" element={<Jaguarhireinpune />} />
<Route path="/Tata-Winger-On-Rent-in-Pune" element={<Tatawingeronrentinpune />} />
<Route path="/Tempo-Traveller-On-Rent-in-Pune-for-Outstation" element={<Tempotravelleronrent />} />
<Route path="/Urbania-On-Rent-in-Pune" element={<Urbaniaonrentinpune />} />


        </Routes>
    {/* <Foot/> */}
    <Footer/>
    </Router>
 

  );
}

export default App;
